import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../Context/UserContextAPI";
import toast from "react-hot-toast";

const TableTypeComponent = ({ investigation }) => {
  const { accessPerm } = useContext(UserContext);

  const [checked, setChecked] = useState(true);
  const [unitList, setUnitList] = useState([]);
  const [tableReportData, setTableReportData] = useState([
    {
      investigation_id: "",
      name: "",
      uom_id: "",
      reference: "",
      info: "",
      order_no: "",
      value_type: "",
      dropdown_value: "",
      status: "true",
    },
  ]);

  const handleTableReportChanges = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...tableReportData];
    onchangeVal[i][name] = value;
    setTableReportData(onchangeVal);
  };
  const plusTR = () => {
    setTableReportData([
      ...tableReportData,
      {
        investigation_id: "",
        name: "",
        uom_id: "",
        reference: "",
        info: "",
        order_no: "",
        value_type: "",
        dropdown_value: "",
        status: "",
      },
    ]);
  };

  const delTR = (i) => {
    if (i < 0 || i >= tableReportData.length) {
      console.log("not delete");
    } else {
      const deleteVal = [...tableReportData];
      // console.log(i);
      deleteVal.splice(i, 1);
      setTableReportData(deleteVal);
    }
  };
  const handleCheck = (e, i) => {
    const { name, value } = e.target;
    setChecked(!checked);
    const onchangeVal = [...tableReportData];
    onchangeVal[i][name] = e.target.checked;
    setTableReportData(onchangeVal);
  };
  const handleUnitChange = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...tableReportData];
    onchangeVal[i][name] = value;
    setTableReportData(onchangeVal);
  };
  const handleValueTypeChange = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...tableReportData];
    onchangeVal[i][name] = value;
    setTableReportData(onchangeVal);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
      investigationId: investigation.id,
      testData: tableReportData,
    };
    const url = `${process.env.REACT_APP_API_BASE_URL}/test/`;
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      })
      .then((response) => {
        if (response.status === 201) {
          toast.success("Successfully updated test!");
        }
      })
      .catch((err) => console.log(err));
  };
  const fetchUnitList = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/test/uom-data`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      })
      .then((response) => setUnitList(response.data.data))
      .catch((err) => console.log(err));
  };

  const fetchTablereportData = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/test/${investigation.id}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      })
      .then((response) => {
        const { status, data } = response.data;

        if (status === "OK") {
          if (data.length === 0) {
            setTableReportData([
              {
                investigation_id: "",
                name: "",
                uom_id: "",
                reference: "",
                info: "",
                order_no: "",
                value_type: "",
                dropdown_value: "",
                status: "true",
              },
            ]);
          } else {
            setTableReportData(data);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchUnitList();
    fetchTablereportData();
  }, [investigation]);

  return (
    <div>
      <div className="row">
        <hr />
        {/* <h6 className="text-danger">Report Type: Table</h6> */}
        <div className="col-sm-12">
          {/* Instrument Table */}
          <div className="table-responsive mt-3">
            <table className="table align-middle">
              <thead className="table-success">
                <tr>
                  <th>
                    Name <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>
                    Unit <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>
                    Reference <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>
                    Normal Value <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>Order No.</th>
                  <th>Value Type</th>
                  <th>Dropdown Value</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableReportData.map((val, i) => (
                  <tr key={i}>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <input
                            name="name"
                            type="text"
                            onChange={(e) => handleTableReportChanges(e, i)}
                            value={val.name}
                            className="form-control"
                            id="inputName"
                            required
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <select
                            value={val.uom_id}
                            onChange={(e) => {
                              handleUnitChange(e, i);
                            }}
                            name="uom_id"
                            className="single-select form-select"
                          >
                            <option value={0}>Select Unit</option>
                            {unitList.map((unit, index) => (
                              <option key={index} value={unit.id}>
                                {unit.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <input
                            name="reference"
                            type="text"
                            onChange={(e) => handleTableReportChanges(e, i)}
                            value={val.reference}
                            className="form-control"
                            id="inputReference"
                            required
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <input
                            name="info"
                            type="text"
                            onChange={(e) => handleTableReportChanges(e, i)}
                            value={val.info}
                            className="form-control"
                            id="info"
                            required
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <input
                            name="order_no"
                            type="number"
                            onChange={(e) => handleTableReportChanges(e, i)}
                            value={val.order_no}
                            className="form-control"
                            id="info"
                            required
                          />
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <select
                            value={val.value_type}
                            onChange={(e) => {
                              handleValueTypeChange(e, i);
                            }}
                            name="value_type"
                            className="single-select form-select"
                          >
                            <option value={""} selected>
                              Choose One...
                            </option>
                            <option value={"Text Input"}>Text Input</option>
                            <option value={"Number Input"}>Number Input</option>
                            <option value={"Dropdown"}>Dropdown</option>
                          </select>
                        </div>
                      </div>
                    </td>
                    <td>
                      {val.value_type === "Dropdown" && (
                        <div className="mb-3 row ">
                          <div className="col-sm-9">
                            <input
                              name="dropdown_value"
                              type="text"
                              onChange={(e) => handleTableReportChanges(e, i)}
                              value={val.dropdown_value}
                              className="form-control"
                              id="inputName"
                            />
                          </div>
                        </div>
                      )}
                    </td>
                    <td>
                      <div className="mb-3 row ">
                        <div className="col-sm-9">
                          <input
                            onChange={(e) => handleCheck(e, i)}
                            defaultChecked={val?.status}
                            name="status"
                            className="form-check-input mt-0 me-2"
                            type="checkbox"
                            id={`"flexCheckChecked-${i}"`}
                          />
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="table-actions d-flex align-items-center gap-3 fs-6">
                        {i === tableReportData.length - 1 ? (
                          <div className="d-flex align-items-center gap-3 fs-6">
                            <button
                              className="text-primary border-0 bg-transparent"
                              title="Views"
                              onClick={plusTR}
                            >
                              <i className="bi bi-plus-circle-fill" />
                            </button>
                            {i > 0 ? (
                              // eslint-disable-next-line jsx-a11y/anchor-is-valid
                              <button
                                className="text-danger border-0 bg-transparent"
                                title="Delete"
                                onClick={() => delTR(i)}
                              >
                                <i className="bi bi-trash-fill" />
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="col-3">
              <button
                type="submit"
                className="btn btn-success px-5"
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableTypeComponent;
